import React from "react";

/**
 * Reusable Numbered Card Component (for Highlights)
 * @param {number} number - Card number (1-indexed)
 * @param {string} title - Card title
 * @param {string} text - Card description
 */
const NumberedCard = ({ number, title, text }) => (
  <div className="highlight-card-item">
    <div className="highlight-number">
      {String(number).padStart(2, "0")}
    </div>
    <div className="ms-2">
      <h6 className="fw-bold mb-1" style={{ fontSize: "18px" }}>
        {title}
      </h6>
      <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
        {text}
      </p>
    </div>
  </div>
);

export default NumberedCard;
